export default {
  outbound: 'Aller',
  inbound: 'Retour',
  hide: 'Fermer',
  details: "Plus d'infos",
}
